import { observer } from "mobx-react-lite";
import React from "react";
import cs from "classnames";
import classes from "./PreviewFooter.module.scss";
import { NavLink } from "react-router-dom/cjs/react-router-dom";
import { APPLICATION_ROUTES } from "../../../constants";
import ShareButton from "../ShareButton";
import SubmitAnswerButton from "../SubmitAnswerButton";
import ColoringPageButton from "../ColoringPageButton";
import { isMobile } from "react-device-detect";

const PreviewFooter = observer(
  ({ videoInfo, sharePage, submitAnswer, pdfHandler, file }) => {
    return (
      <div className={cs(classes.previewFooter)}>
        <div className={cs(classes.previewInfo)}>
          <div className={classes.videoTags}>
            {videoInfo.tags &&
              videoInfo.tags.map(
                (tag, index) =>
                  tag.name_hebrew && (
                    <NavLink
                      target="_blank"
                      key={tag.id + index}
                      to={`${APPLICATION_ROUTES.HOME}?keyword=${tag.name_hebrew}`}
                    >
                      #{tag.name_hebrew}
                    </NavLink>
                  )
              )}
          </div>
        </div>
        <div className={cs(classes.previewButtons)}>
          <ShareButton size={isMobile ? "xs" : "m"} sharePage={sharePage} />
          {file && (
            <ColoringPageButton
              size={isMobile ? "xs" : "m"}
              pdfHandler={pdfHandler}
            />
          )}
          <SubmitAnswerButton
            size={isMobile ? "xs" : "m"}
            submitAnswer={submitAnswer}
            // color={isMobile ? "white" : ""}
          />
        </div>
      </div>
    );
  }
);

export default PreviewFooter;
